
import Swal from 'sweetalert2'

export default{
    servidor : 'https://dmini.sistemizeapps.com',

    dadoslancto: [],

    //
    //servidor : 'http://localhost/dracomini',
    sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    },
    reqaxios(parametros, metodo, url){
        let axios        = require('axios');
        let bodyFormData = new FormData(); 

        for (let i = 0; i < parametros.length; i++){
            let pmt = parametros[i].parametro;
            let vl  = parametros[i].valor;
            bodyFormData.append(pmt, vl);    
        }
        return axios({
            method: metodo,
          
            url : url,
            data: bodyFormData,
            headers: {'Content-Type': 'multipart/form-data' }            
        });           
    }, 
    notif(tipo, titulo, texto){

        if(tipo == 'error'){
            Swal.fire({
                icon: "error",
                title: titulo,
                text: texto
              });
        }else{
            Swal.fire({
                position: "top-end",
                title: titulo,
                text: texto,
                showConfirmButton: false,
                timer: 1500,
                icon: tipo
              });
        }
    },
    formatavalordecimais(valor, digitos) {
        //return valor.toLocaleString('pt-br', {minimumFractionDigits: digitos});
        //return valor.toFixed(digitos).replace('.', ',');        
        return valor.formatMoney(digitos, "", ".", ",");
    },    
    formatarvalor(value, cifra) {
        var val = (value / 1).toFixed(2).replace('.', ',');
        if (cifra == '') {
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        } else {
            return cifra + ' ' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        }
    },
    gerardadoslegendagrafico(arraydados){
        let dadoslegenda = [];
        for (let item of arraydados) {
            dadoslegenda.push(item.name);
        }
        return dadoslegenda;
    },
    resetZoom() {
        const metaViewport = document.querySelector('meta[name="viewport"]');
        if (metaViewport) {
          metaViewport.setAttribute("content", "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no");
        }
    },
    atzdash(){
        document.getElementById("btdash").click();
    },
    DataBRtoObJ(dataStr){
        const partes = dataStr.split('/');
        if (partes.length !== 3) return null; // Retorna null se o formato estiver incorreto

        const dia = parseInt(partes[0], 10);
        const mes = parseInt(partes[1], 10) - 1; // Mês no JS começa do zero (jan = 0)
        const ano = parseInt(partes[2], 10);

        return new Date(ano, mes, dia);
    },
    formatarDataBR(dataString) {
        const data = new Date(dataString);

        const dia = String(data.getDate()).padStart(2, '0');
        const mes = String(data.getMonth() + 1).padStart(2, '0'); // Janeiro é 0
        const ano = data.getFullYear();

        return `${dia}/${mes}/${ano}`;
    },
    gerarStringAleatoria(tamanho = 10) {
        const caracteres = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
        let resultado    = ''
        for (let i = 0; i < tamanho; i++) {
            const indice = Math.floor(Math.random() * caracteres.length)
            resultado += caracteres.charAt(indice)
        }
        return resultado
    }
}